import React from 'react'
import GenderSplit from './data/GenderSplit';
import GenderSplitPc from './data/GenderSplitPc';
import LivingWage from './data/LivingWage';
import GHGEmissions from './data/GHGEmissions';
import PayGap from './data/PayGap';
import GenderPayGap from './data/GenderPayGap';
import Bonuses from './data/Bonuses';
import BoardGender from './data/BoardGender';
import BoardDiversity from './data/BoardDiversity';
import Policies from './data/Policies';
import { GenerateChartsProps } from './common';

const GenerateCharts = React.memo((props: GenerateChartsProps) => {
  return <div
    style={{ height: 0, width: 0, overflow: 'hidden' }}
  >
    <GenderSplit {...props} />
    <GenderSplitPc {...props} />
    <LivingWage {...props} />
    <GHGEmissions {...props} />
    <PayGap {...props} />
    <GenderPayGap {...props} />
    <Bonuses {...props} />
    <BoardGender {...props} />
    <BoardDiversity {...props} />
    <Policies {...props} />
  </div>
})

export default GenerateCharts;
